import { VF_DATE_PICKER } from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import moment from 'moment-timezone';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import {
  isCrqEmergency,
} from '../common-logic';
import { scheduledStartDate } from './scheduled-start-date';
import { scheduledEndDate } from './scheduled-end-date';


const fieldId = 'outage_start_date';

const validator = (params) => {
  const {
    values,
    field,
    formData,
  } = params;
  const {
    optional,
  } = field;
  const value = values[fieldId];

  const isEmergency = isCrqEmergency(formData);
  // const minDate = field.componentData.vFParams.minDate;
  // const dateIsBeforeMin = commonValidation.date.isBeforeMinDate(value, minDate);
  // const maxMinutesDiff = 30;
  // const maxYearDiff = 5;
  const maxOneMinDiff = 1;

  const thisMoment = moment.tz(values[fieldId], DEFAULT_TIMEZONE).startOf('minute');
  const startMoment = moment.tz(values[scheduledStartDate.id], DEFAULT_TIMEZONE).startOf('minute');

  // figure out the differences between thisMoment and startMoment
  const timeDiffMinutes = thisMoment.diff(startMoment, 'minutes');
  const moreThanMaxOneMinDiff = timeDiffMinutes < maxOneMinDiff;
  // const timeDiffYears = thisMoment.diff(startMoment, 'years');

  // ie, 1:00 -> 1:29 === error but 1:00 -> 1:30 is fine!
  // const lessThanMaxMinutesDiff = timeDiffMinutes < maxMinutesDiff;
  // const moreThanMaxYearDiff = timeDiffYears >= maxYearDiff;

  const dateIsAfterStart = commonValidation.date.isAfterMaxDate(value, moment(values[scheduledEndDate.id]));
  const dateIsBeforeEnd = commonValidation.date.isBeforeMinDate(value, moment(values[scheduledStartDate.id]));


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(value, VF_DATE_PICKER);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option' : null);
  errors[INLINE_ERRORS].push(moreThanMaxOneMinDiff && isEmergency ? 'Outage Start date/time must be at least 1min after the Scheduled Start date/time & before the Scheduled End date/time.' : null);
  // errors[INLINE_ERRORS].push(lessThanMaxMinutesDiff ? 'Outage Start date/time must be at least 30mins after the Scheduled start date/time' : null);
  // errors[INLINE_ERRORS].push(moreThanMaxYearDiff ? 'Outage date/time must be within 5 years of schedule start date/time' : null);
  errors[INLINE_ERRORS].push((dateIsAfterStart || dateIsBeforeEnd) && !isEmergency ? 'Outage Start date/time must be between scheduled start & end date/time' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

// This overwritten by the form :)
const initialValues = null;

const vFParams = {
  fieldTitle: 'Outage start date/time',
  displayType: 'big',
};

const owStartDate = {
  id: fieldId,
  validator,
  vFParams,
  initialValues,
  fieldType: VF_DATE_PICKER,
};

export { owStartDate };
